import { BRANDS } from './branding'
import { previewNotice } from './previewNotice'
import { useBrand } from './useBrand'

/**
 * Marks the app as re-skinned, and offers the way out.
 *
 * The re-skin is per-browser and survives a reload, so an admin who switched
 * for one demo comes back to an orange app with their colleagues' names hidden
 * and, until now, nothing on screen explaining either.
 *
 * It deliberately takes no accent colour. The accent *is* the brand being
 * previewed, so an accented badge is the one thing guaranteed to blend into
 * what it is there to point out. Dashed, inked, and sitting next to the logo it
 * is contradicting.
 */
export function BrandPreviewBadge() {
  const { brand, setBrand, anonymised } = useBrand()

  if (brand.key === 'yllw') return null

  const notice = previewNotice(brand.name, BRANDS.yllw.name, anonymised)

  return (
    <button
      type="button"
      onClick={() => setBrand('yllw')}
      title={notice}
      aria-label={notice}
      className="inline-flex items-center gap-1.5 shrink-0 cursor-pointer
                 border border-dashed border-ink-300 bg-paper
                 px-2 py-1 rounded-[2px]
                 text-[10px] uppercase tracking-[0.1em] text-ink-700
                 hover:border-ink-1000 hover:text-ink-1000
                 transition-colors duration-[var(--dur-fast)]"
    >
      <span className="font-semibold">{brand.name}-vy</span>
      <span className="max-[900px]:hidden normal-case tracking-normal text-ink-500">
        bara du
      </span>
      <span aria-hidden="true" className="text-ink-500">×</span>
    </button>
  )
}
